function set(name, value, expire = 7 * 24 * 3600) {
  try {
    // Remove existing cookie first to prevent duplicates
    erase(name);

    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + expire * 1000);

    const encodedValue = encodeURIComponent(
      typeof value === 'string' ? value : JSON.stringify(value)
    );

    document.cookie = `${name}=${encodedValue};expires=${expiryDate.toUTCString()};path=/;SameSite=Lax${window.location.protocol === 'https:' ? ';Secure' : ''}`;
  } catch (error) {
    console.error('Error setting cookie:', error);
  }
}

// Set cookie with domain attribute for cross-subdomain access
function setWithDomain(name, value, options = {}) {
  try {
    // FIRST: Remove any existing cookie with the same name to prevent duplicates
    eraseAll(name);

    const {
      expire = 7 * 24 * 3600,
      domain = null,
      sameSite = 'Lax' // Use Lax for cross-subdomain (Strict blocks subdomain access)
    } = options;

    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + expire * 1000);

    // Don't double-encode if value is already a JSON string
    let encodedValue;
    if (typeof value === 'string') {
      // Check if it's already JSON
      try {
        JSON.parse(value);
        // It's valid JSON, just encode it
        encodedValue = encodeURIComponent(value);
      } catch (e) {
        // Not JSON, encode as-is
        encodedValue = encodeURIComponent(value);
      }
    } else {
      encodedValue = encodeURIComponent(JSON.stringify(value));
    }

    // Extract root domain if not provided
    const hostname = window.location.hostname;
    let rootDomain;

    // Handle localhost and IP addresses
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
      rootDomain = hostname; // Don't add dot prefix for localhost
    } else {
      // Extract root domain properly
      // For stg.solfin.co.in → solfin.co.in
      // For stg-internal.solfin.co.in → solfin.co.in
      // For app.example.com → example.com
      const parts = hostname.split('.');

      // Handle different TLD scenarios
      if (parts.length >= 3 && parts[parts.length - 2].length <= 3) {
        // Likely a two-part TLD like .co.in, .co.uk, .com.au
        rootDomain = parts.slice(-3).join('.');
      } else if (parts.length >= 2) {
        // Regular TLD like .com, .org
        rootDomain = parts.slice(-2).join('.');
      } else {
        rootDomain = hostname;
      }
    }

    const domainAttr = (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.match(/^\d+\.\d+\.\d+\.\d+$/))
      ? ''
      : `;domain=.${rootDomain}`;

    const cookieString = `${name}=${encodedValue};expires=${expiryDate.toUTCString()};path=/${domainAttr};SameSite=${sameSite}${window.location.protocol === 'https:' ? ';Secure' : ''}`;

    console.log(`🍪 Setting cookie: ${name}`);
    console.log(`   📍 Hostname: ${hostname}`);
    console.log(`   🌐 Root domain: ${rootDomain}`);
    console.log(`   📝 Cookie string: ${cookieString.substring(0, 100)}...`);

    document.cookie = cookieString;

    // Verify it was set
    const verification = document.cookie.includes(`${name}=`);
    console.log(`   ${verification ? '✅' : '❌'} Cookie ${verification ? 'set successfully' : 'FAILED to set'}`);
  } catch (error) {
    console.error('❌ Error setting cross-domain cookie:', error);
  }
}

function get(name) {
  try {
    const cookieStr = document.cookie
      .split(';')
      .find((cookie) => cookie.trim().startsWith(`${name}=`));

    if (!cookieStr) return null;

    const encodedValue = cookieStr.split('=')[1].trim();
    if (!encodedValue) return null;

    const decodedValue = decodeURIComponent(encodedValue);

    try {
      return JSON.parse(decodedValue);
    } catch {
      return decodedValue;
    }
  } catch (error) {
    console.error('Error getting cookie:', error);
    return null;
  }
}

function erase(name) {
  try {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax${window.location.protocol === 'https:' ? ';Secure' : ''}`;
  } catch (error) {
    console.error('Error erasing cookie:', error);
  }
}

// Comprehensive erase that removes cookie from all possible domain/path combinations
function eraseAll(name) {
  try {
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.match(/^\d+\.\d+\.\d+\.\d+$/);
    const isSecure = window.location.protocol === 'https:';
    const sameSiteOptions = ['Strict', 'Lax', 'None'];

    console.log(`🗑️  Removing all instances of cookie: ${name}`);
    console.log(`   📍 Hostname: ${hostname}`);

    // 1. Remove from current domain without any attributes
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

    // 2. Remove with different SameSite values (no domain)
    sameSiteOptions.forEach(sameSite => {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=${sameSite}${isSecure ? ';Secure' : ''}`;
    });

    if (!isLocal) {
      // Extract root domain
      const parts = hostname.split('.');
      let rootDomain;

      if (parts.length >= 3 && parts[parts.length - 2].length <= 3) {
        rootDomain = parts.slice(-3).join('.');
      } else if (parts.length >= 2) {
        rootDomain = parts.slice(-2).join('.');
      } else {
        rootDomain = hostname;
      }

      console.log(`   🌐 Root domain: ${rootDomain}`);

      // 3. Remove from root domain with leading dot
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${rootDomain}`;

      // 4. Remove from root domain without leading dot
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${rootDomain}`;

      // 5. Remove from current hostname
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname}`;

      // 6. Remove with all combinations of domain and SameSite
      sameSiteOptions.forEach(sameSite => {
        // With leading dot
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${rootDomain};SameSite=${sameSite}${isSecure ? ';Secure' : ''}`;

        // Without leading dot
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${rootDomain};SameSite=${sameSite}${isSecure ? ';Secure' : ''}`;

        // With current hostname
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname};SameSite=${sameSite}${isSecure ? ';Secure' : ''}`;
      });
    }

    // Verify removal
    const stillExists = document.cookie.includes(`${name}=`);
    console.log(`   ${stillExists ? '⚠️  Cookie still exists (may be HttpOnly)' : '✅ Cookie completely removed'}`);
  } catch (error) {
    console.error('❌ Error erasing cookie comprehensively:', error);
  }
}

/**
 * Check if a specific cookie exists
 * @param {string} name - Cookie name
 * @returns {boolean} true if cookie exists, false otherwise
 */
function has(name) {
  if (typeof window === 'undefined') return false;
  return document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${name}=`));
}

/**
 * Validate that required auth cookies exist
 * @returns {boolean} true if all required auth cookies exist, false otherwise
 */
function hasValidAuthCookies() {
  if (typeof window === 'undefined') return false;

  const hasRootCookie = has('root');
  const hasUserCookie = has('user');

  console.log('🔍 Checking auth cookies:', { hasRootCookie, hasUserCookie });

  // Both root and user cookies must exist
  return hasRootCookie && hasUserCookie;
}

export const cookie = {
  get,
  set,
  setWithDomain,
  erase,
  eraseAll,
  has,
  hasValidAuthCookies
};
